<template>
	<v-menu offset-y left origin="right top" z-index="99" content-class="notification-dropdown" transition="slide-y-transition" nudge-top="-10">
		<v-btn class="notification-icon ma-0"  icon large slot="activator">
			<i class="zmdi grey--text zmdi-notifications-active zmdi-hc-fw font-lg" :class="{ 'animated infinite wobble': notifications }"></i>
		</v-btn>
		<div class="dropdown-content">
			<div class="dropdown-top d-custom-flex justify-space-between primary">
				<span class="white--text fw-bold">Notifications</span>
				<!-- <span class="v-badge warning">4 NEW</span> -->
			</div>
			<v-list class="dropdown-list">
				<v-list-tile to="/orderhistory" v-if="newOrderCount > 0">
					<i class="mr-3 zmdi zmdi-storage primary--text"></i>
					<span>{{newOrderCount}} new orders</span>
				</v-list-tile>
				<div class="text-xs-center" v-if="!notifications">
					No Notification
				</div>
			</v-list>
		</div>
	</v-menu>
</template>

<script>
    import { mapGetters } from 'vuex'

	export default {
		data() {
			return {
			}
		},
		computed: {
			...mapGetters([
				'newOrderCount'
			]),
			notifications: function() {
				if (this.newOrderCount > 0) {
					return true
				}
				return false
			}
		}
	}
</script>
